import { motion } from "framer-motion";
import { MessageSquare, Palette, Code, Settings, GraduationCap, Headphones, TrendingUp } from "lucide-react";
import { useTranslation } from "@/hooks/useTranslation";

const ProcessFlow = () => {
  const { t } = useTranslation();
  
  const processSteps = [{
    title: t.processFlow.steps.step1.title,
    description: t.processFlow.steps.step1.description,
    icon: MessageSquare,
    iconColor: "#FFFFFF",
    solidColor: "#A9E0DD",
    shadowColor: "shadow-[#A9E0DD]/20",
    position: "left"
  }, {
    title: t.processFlow.steps.step2.title,
    description: t.processFlow.steps.step2.description,
    icon: Palette,
    iconColor: "#FFFFFF",
    solidColor: "#66B3BB",
    shadowColor: "shadow-[#66B3BB]/20",
    position: "right"
  }, {
    title: t.processFlow.steps.step3.title,
    description: t.processFlow.steps.step3.description,
    icon: Code,
    iconColor: "#FFFFFF",
    solidColor: "#C8DDFF",
    shadowColor: "shadow-[#C8DDFF]/20",
    position: "left"
  }, {
    title: t.processFlow.steps.step4.title,
    description: t.processFlow.steps.step4.description,
    icon: Settings,
    iconColor: "#FFFFFF",
    solidColor: "#868EAD",
    shadowColor: "shadow-[#868EAD]/20",
    position: "right"
  }, {
    title: t.processFlow.steps.step5.title,
    description: t.processFlow.steps.step5.description,
    icon: GraduationCap,
    iconColor: "#FFFFFF",
    solidColor: "#B4C3FD",
    shadowColor: "shadow-[#B4C3FD]/20",
    position: "left"
  }, {
    title: t.processFlow.steps.step6.title,
    description: t.processFlow.steps.step6.description,
    icon: Headphones,
    iconColor: "#FFFFFF",
    solidColor: "#70989c",
    shadowColor: "shadow-[#70989c]/20",
    position: "right"
  }, {
    title: t.processFlow.steps.step7.title,
    description: t.processFlow.steps.step7.description,
    icon: TrendingUp,
    iconColor: "#FFFFFF",
    solidColor: "#A9E0DD",
    shadowColor: "shadow-[#A9E0DD]/20",
    position: "left"
  }];
  
  return <section className="py-24 relative overflow-hidden">
      <div className="container mx-auto px-4 relative z-10">
        

        <div className="max-w-6xl mx-auto relative">
          {/* Central Timeline - Animated Flowing Dots */}
          <div className="absolute left-1/2 top-0 bottom-0 transform -translate-x-1/2 block z-0">
            <div className="relative w-1 h-full">
              {/* Base line */}
              <div className="absolute inset-0 w-px bg-gradient-to-b from-transparent via-[#00808D]/60 to-transparent ml-0.5"></div>
            </div>
          </div>
          
          {processSteps.map((step, index) => <motion.div key={index} className={`relative z-10 mb-20 flex items-center lg:items-start ${step.position === "right" ? "lg:flex-row-reverse" : ""} flex-col lg:flex-row`} initial={{
          opacity: 1,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: "-50px"
        }} transition={{
          duration: 0.8,
          delay: index * 0.1,
          ease: [0.25, 0.4, 0.25, 1]
        }}>
              {/* Timeline Dot with Heartbeat */}
              {index > 0 && <div className="absolute left-1/2 transform -translate-x-1/2 block z-20">
                  <motion.div className="w-4 h-4 bg-white rounded-full border-4 shadow-lg border-primary/40" animate={{
              scale: [1, 1.1, 1],
              boxShadow: [`0 0 0 0 hsl(var(--primary) / 0.3)`, `0 0 0 8px hsl(var(--primary) / 0.1)`, `0 0 0 0 hsl(var(--primary) / 0.3)`]
            }} transition={{
              duration: 2,
              repeat: Infinity,
              delay: index * 0.2,
              ease: [0.4, 0, 0.6, 1]
            }} />
                </div>}

              {/* Content Card */}
              <motion.div className={`flex-1 max-w-lg ${step.position === "right" ? "lg:mr-12" : "lg:ml-12"} mb-8 lg:mb-0`} whileHover={{
            y: -4,
            transition: {
              duration: 0.2,
              ease: [0.4, 0, 0.2, 1]
            }
          }}>
                <div className="backdrop-blur-sm rounded-2xl p-8 shadow-xl border border-white/20 hover:shadow-2xl transition-all duration-500 ease-out relative z-10" style={{
              backgroundColor: step.solidColor
            }}>
                  <div className={`inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-white/20 shadow-lg mb-6 transform rotate-3 hover:rotate-0 transition-transform duration-300`}>
                    <step.icon className="w-8 h-8 text-white" />
                  </div>
                  
                  <h2 className="text-2xl font-bold mb-4 leading-tight text-slate-800">
                    {step.title}
                  </h2>
                  <p className="leading-relaxed text-lg text-slate-950">
                    {step.description}
                  </p>
                </div>
              </motion.div>
            </motion.div>)}
        </div>

        {/* Bottom CTA */}
        
      </div>
    </section>;
};
export default ProcessFlow;